import { TranslocoService } from '@ngneat/transloco';
import { Component, Input, OnInit } from '@angular/core';
import { UserService } from '../../../core/user/user.service';
import { OverrideService } from '../../../../@shelter/utils/override.service';
import { AuthService } from '../../../core/auth/auth.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';

export type EntityData = {
  name: string;
  route: string;
  addRoute?: string;
  add?: boolean ;
  onExport : ()=>void;
  onFilter: (value: string)=>void;
  isExport?:boolean ;

}

@Component({
  selector: 'all-design',
  templateUrl: './all-design.component.html',
  styleUrls: ['./all-design.component.scss']
})
export class AllDesignComponent implements OnInit {

  @Input() entityData: EntityData;
  constructor(public override: OverrideService,
    public translate: TranslocoService,
    private _userService: UserService,
    private _authService: AuthService,
    private router:Router) { }

  searchValue: string;
  ngOnInit(): void {
  }
  add () {
    this._authService?.signInUsingToken().subscribe(res=> {
      console.log('res',res);
      if(res) {
        this.entityData.addRoute ?
        this.router.navigate([this.entityData.addRoute] ):this.router.navigate( ['/', this.entityData.route, 'add'])
      }
      
    })

  //   this._userService.user$.subscribe(user=>{
  //     console.log('user: ' + user);
      
  //     if(!user?.isActive) {
  //         this._authService.signOut()
  //     this.router.navigate(['/sign-in'])
  //     this._snackBar.open('User is deactivated','',{ duration: 5000 });
          
  //     }
  //     else {
  //       this.entityData.addRoute ?
  //        this.router.navigate([this.entityData.addRoute] ):this.router.navigate( ['/', this.entityData.route, 'add'])
  //     }
  // })
  }

}
